var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1863_365",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1863_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06667 10.7001L11.7667 6.00008L10.8333 5.06675L7.06667 8.83341L5.16667 6.93341L4.23333 7.86675L7.06667 10.7001ZM3.33333 14.0001C2.96667 14.0001 2.65267 13.8696 2.39133 13.6087C2.13044 13.3474 2 13.0334 2 12.6667V3.33341C2 2.96675 2.13044 2.65275 2.39133 2.39141C2.65267 2.13053 2.96667 2.00008 3.33333 2.00008H6.13333C6.27778 1.60008 6.51956 1.27786 6.85867 1.03341C7.19733 0.78897 7.57778 0.666748 8 0.666748C8.42222 0.666748 8.80289 0.78897 9.142 1.03341C9.48067 1.27786 9.72222 1.60008 9.86667 2.00008H12.6667C13.0333 2.00008 13.3473 2.13053 13.6087 2.39141C13.8696 2.65275 14 2.96675 14 3.33341V12.6667C14 13.0334 13.8696 13.3474 13.6087 13.6087C13.3473 13.8696 13.0333 14.0001 12.6667 14.0001H3.33333ZM3.33333 12.6667H12.6667V3.33341H3.33333V12.6667ZM8 2.83341C8.14444 2.83341 8.264 2.78608 8.35867 2.69141C8.45289 2.59719 8.5 2.47786 8.5 2.33341C8.5 2.18897 8.45289 2.06941 8.35867 1.97475C8.264 1.88053 8.14444 1.83341 8 1.83341C7.85556 1.83341 7.73622 1.88053 7.642 1.97475C7.54733 2.06941 7.5 2.18897 7.5 2.33341C7.5 2.47786 7.54733 2.59719 7.642 2.69141C7.73622 2.78608 7.85556 2.83341 8 2.83341Z",
    fill: "#828282"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.269c8430162b23c0128cd16cd867d612.svg";
export { ForwardRef as ReactComponent };